import React from 'react'
import { Table } from 'semantic-ui-react'
import MoverHerramienta from './MoverHerramienta'
import AlmDropdown from '../../../componentes/AlmDropdown'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { AuthContext } from '../../../Auth'

class Inventario extends React.Component{
    static contextType = AuthContext
    constructor(props){
        super(props)
        this.database=firebase.firestore()
        this.state={
            rows:[],
            filtro:'',
            useModal: false,
            nombre: '',
            cantidad: 0
        }
    }
    componentDidMount() {
        this.getData()
    }
    componentDidUpdate(prevProps, prevState){
        if(this.state.filtro!==prevState.filtro){
            this.getData()
        }
    }
    setReference=()=>{
        let dbReference=this.database.collection('InventarioH')
        if (!this.state.filtro)  {return dbReference}
        dbReference=this.filtro(dbReference)
        return dbReference
    }
    filtro=dbReference=>{
        return dbReference.where('ubicacion', '==', this.state.filtro)   
    }
    getData= async ()=>{
        this.setReference().orderBy('herramienta', 'asc')
        .onSnapshot(snap=>{
            const rows=[]
            for(let i=0; i<snap.docs.length;i++){
                rows.push({
                    id: snap.docs[i].id,
                    ...snap.docs[i].data()
                })
            }
            this.setState({
                rows:rows
            })
        })
    }
    handlefiltroChange=(e, {value})=>{
        this.setState({filtro:value})
    }
    admin =(row)=>{
		if (this.context.currentUser.rol === "admin" || this.context.currentUser.rol === "warehouseAdmin"){
			return(
                <MoverHerramienta
                    data={row}
                    pasadoPor={this.context.currentUser.name}
                    actualizar={this.getData}
                />
			)
		}
	}
    render(){
        return(
        <>
        <div className="filtros">
            <div>
                <div>Almacén:</div>
                <AlmDropdown 
                    placeholder='almacén'
                    value={this.state.filtro} 
                    onChange={this.handlefiltroChange} 
                    all={1} 
                />
            </div>
        </div>
        <div  className="body tabla">
            <table><tbody>
                <tr>
                    <th>Nombre</th>
                    <th>Ubicacion</th>
                    <th>Fecha</th>
                </tr>
                {this.state.rows.map((row, i)=>{
                    return(
                        <Table.Row key={i}>
                            <Table.Cell>{row.herramienta}</Table.Cell>
                            <Table.Cell>{row.ubicacion}</Table.Cell>
                            <Table.Cell>{row.fecha ? row.fecha.toDate().toLocaleDateString():null}</Table.Cell>
                            <Table.Cell>{this.admin(row)}</Table.Cell>
                        </Table.Row>
                    )
                })}
            </tbody></table>
        </div>
        </>
        )
    }
}

export default Inventario